/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約検索情報
 */
export interface Sgkb986aReqCtrSearchInfoDto {
    /**
     * 内部お客さま番号
     */
    visitNo?: string;
    /**
     * お客さま漢字氏名
     */
    visitName?: string;
    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * 契約お客さま番号リスト
     */
    firstSrvctrNoList?: Array<string>;
    /**
     * サービス種別コードリスト
     */
    srvClsfyCodeList?: Array<string>;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * 外部接続番号
     */
    extCnnctNo?: string;
    /**
     * 契約状況
     */
    ctrStatus?: string;
    /**
     * 契約開始日付（ＦＲＯＭ）
     */
    ctrefctkiStrtdateFrom?: string;
    /**
     * 契約開始日付（ＴＯ）
     */
    ctrefctkiStrtdateTo?: string;
    /**
     * 外部連携ID
     */
    extLinkId?: string;
    /**
     * 契約一覧ソートパターンコード
     */
    contractlistSortPatterncode?: string;
}

